import React from 'react'
import "./Navigation.scss"
import { useSelector } from 'react-redux';
import { State } from '../../app/store';
import BasketNavButton from './shared/BasketNavButton';
import EAButton from '../../app/components/shared/Buttons/EAButton';
import { useTranslation } from 'react-i18next';
import { goToPreviousPage } from '../../utils/goToPreviousPage';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdArrowBackIosNew } from 'react-icons/md';
import { CUSTOM_OFFER } from '../../app/routes';
import useDesktopSize from '../../utils/hooks/useDesktopSize';
import EAIconButton from '../../app/components/shared/Buttons/EAIconButton';

const SimplifiedNavBar: React.FC = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useDesktopSize();
  
    const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
    const saleConfiguration = useSelector((state: State) => state.config.configuration);

  return (
        <div className="simplified-navbar">
        <a href={saleConfiguration.startPageUrl} target="_parent">
          <img src={logoUrl} alt="Logo sklepu" />
        </a>

<div className="simplified-navbar__links">
        {location.pathname !== CUSTOM_OFFER && (
          <>
          {isDesktop ? ( <EAButton
            title={t("Powrót")}
            onClick={() => goToPreviousPage(navigate, CUSTOM_OFFER)}
            startIcon={<MdArrowBackIosNew />}
            variant="text"
          />) : ( <EAIconButton
            title={t("Powrót")}
            onClick={() => goToPreviousPage(navigate, CUSTOM_OFFER)}
            icon={<MdArrowBackIosNew />}
            variant="icon"
          />)}</>
         
        )}
           
        <BasketNavButton fullwidth={false} />
        </div>
            </div>
  )
}

export default SimplifiedNavBar